<template>
  <div class="container">
    <i @click="deleteF(index)" class="el-icon-circle-close delete_icon"></i>
    <el-form ref="form" :model="form" label-width="50px">
      <el-form-item label="问题">
        <el-input
          :value="form.title"
          @input="changeInput"
          placeholder="请输入问题"
        ></el-input>
      </el-form-item>
      <el-form-item label="解答">
        <rich-text
          @getcode="getcode"
          :id="'id' + Date.now()"
          :ids="'id' + Date.now()"
          :value="form.content"
        ></rich-text>
      </el-form-item>
    </el-form>

    <!--  <div class="mt-4">
          <span class="titlemenu mt-4">{{ item.title }}</span
          ><span class="title-append"></span>
        </div> -->

    <!--  <div class="classManger">
     
    </div> -->
  </div>
</template>

<script>
//import drawerDetail from "@/components/drawerDetail.vue";

import ue2 from "@/components/common/UE2.vue";
import RichText from "./RichText.vue";

export default {
  components: { ue2, RichText },
  props: {
    index: {
      type: Number,
      default: 0,
    },
    value: {
      type: Object,
      default: {},
    },
    /* title: {
      type: String,
      default: "",
    }, */
  },
  data() {
    return {
      form: { title: "", content: "" },
    };
  },
  methods: {
    changeInput(val) {
      this.form.title = val;
      this.changeText();
    },
    deleteF(index) {
      this.$emit("deleteF", index);
    },
    getcode(content) {
      this.form.content = content;
      console.log("kaishi");
      this.changeText();
    },
    changeText() {
      this.$emit(
        "changeText",
        { title: this.form.title, content: this.form.content },
        this.index
      );
    },
  },
  watch: {
    value: {
      handler(val) {
        this.form = val;
      },
      deep: true,
      immediate: true,
    },
  },
  created() {
    /*  this.getCampusList();
    this.getPageList(); */
  },
  mounted() {
    /* window.onresize = () => {
      this.setaddDialogwidth();
    }; */
  },
};
</script>
<style scoped>
.container {
  position: relative;
}
.delete_icon {
  display: block;
  position: absolute;
  top: 3%;
  left: -12px;

  z-index: 2;
  font-size: 16px;
}
.delete_icon:hover {
  color: #66b1ff;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/addGuide/components/FaqCom.vue